import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { Toaster } from 'sonner'

import { AuthLayout } from '@/shared/auth/components/common/layout'

// Routes that shouldn't be redirected to switch accounts if they are already signed in
const IGNORED_ROUTES = ['/signup/switch-accounts', '/signup/azure/confirm']

export const Route = createFileRoute('/signup')({
	beforeLoad: ({ context: { clerk }, location }) => {
		if (clerk.auth?.isSignedIn && !IGNORED_ROUTES.includes(location.pathname)) {
			throw redirect({
				to: '/signup/switch-accounts',
				search: {
					attempt_pathname: location.pathname,
					attempt_search: location.searchStr,
				},
			})
		}
	},
	component: RouteComponent,
})

function RouteComponent() {
	return (
		<AuthLayout>
			<Outlet />

			<div id="clerk-captcha" data-cl-theme="dark" data-cl-size="flexible" />
			<Toaster />
		</AuthLayout>
	)
}
